import { clientWithAuth } from 'dashboard409a/services/base';

// Lightweight wrapper around POST /api/v1/cell-annotations/pre-fx/preview/.
// Written by hand (not via codegen) so adding the endpoint did not require
// re-running `yarn codegen` and churning a thousand generated files. The
// endpoint contract is small enough that a hand-rolled service is clearer
// than threading the codegen output through; if more endpoints land in this
// app the next time codegen runs will absorb this naturally.

export interface PreFxPreviewRequest {
  sourceAmount: number;
  sourceCurrency: string;
  hostCurrency: string;
  // ISO-8601 date (YYYY-MM-DD).
  transactionDate: string;
}

export interface PreFxPreviewResponse {
  hostAmount: number;
}

const PRE_FX_PREVIEW_URL = '/api/v1/cell-annotations/pre-fx/preview/';

// Pre-FX preview call. Resolves with the converted host amount, or rejects
// (axios canceled / network / 400) which the caller treats as "no preview
// available -- leave the host alone." The popout never blocks on this; save
// still re-runs the conversion authoritatively on the backend.
export const fetchPreFxPreview = async (
  request: PreFxPreviewRequest,
  options?: { signal?: AbortSignal }
): Promise<PreFxPreviewResponse> => {
  const { data } = await clientWithAuth.post<{ host_amount: string | number }>(
    PRE_FX_PREVIEW_URL,
    {
      source_amount: request.sourceAmount,
      source_currency: request.sourceCurrency,
      host_currency: request.hostCurrency,
      transaction_date: request.transactionDate,
    },
    { signal: options?.signal }
  );
  return {
    hostAmount: typeof data.host_amount === 'number' ? data.host_amount : Number(data.host_amount),
  };
};
